<template>
  <main class="meta-ads-thank-you">
    <section class="success-card" aria-labelledby="success-title">
      <div class="success-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="m7 12.5 3.25 3.25L17.5 8.5" />
        </svg>
      </div>

      <p class="success-label">Application received</p>
      <h1 id="success-title">Thank you!</h1>
      <p class="success-message">Your application was submitted successfully.</p>
      <div class="success-divider" aria-hidden="true"></div>
      <router-link class="success-link" to="/">Return to Medusa</router-link>
    </section>
  </main>
</template>

<style lang="scss" scoped>
.meta-ads-thank-you {
  @apply flex items-center justify-center px-0 py-10 text-center;
  min-height: calc(100vh - 8rem);
}

.success-card {
  @apply relative w-full max-w-lg overflow-hidden rounded-lg border border-theme-border border-opacity-50 bg-white px-6 py-12 shadow-box;

  &::before {
    @apply absolute left-0 right-0 top-0 h-1 bg-theme-primary;
    content: "";
  }
}

.success-icon {
  @apply mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-theme-green-light text-theme-green-dark;

  svg {
    @apply h-8 w-8;
  }

  path {
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }
}

.success-label {
  @apply mt-6 text-xs font-semibold uppercase tracking-widest text-theme-primary;
}

h1 {
  @apply mt-2 text-3xl font-semibold text-theme-secondary;
}

.success-message {
  @apply mx-auto mt-3 max-w-sm text-base leading-6 text-theme-body;
}

.success-divider {
  @apply mx-auto my-8 h-px w-16 bg-theme-border;
}

.success-link {
  @apply inline-flex items-center justify-center rounded-md border border-theme-secondary px-5 py-2.5 text-sm font-medium text-theme-secondary transition-colors;

  &:hover {
    @apply bg-theme-secondary text-white;
  }

  &:focus {
    @apply outline-none ring-2 ring-theme-primary ring-offset-2;
  }
}

@media (max-width: 639px) {
  .meta-ads-thank-you {
    @apply py-6;
  }

  .success-card {
    @apply px-5 py-10;
  }
}
</style>